<script setup lang="ts">
import type { InfoLevel } from "@/model/baseTypes";
import { infoLevelInfo } from "@/model/baseTypes";

defineProps<{ level?: InfoLevel; top?: number; right?: number }>();
</script>

<template>
  <div
    class="info-marker"
    :style="{
      backgroundColor: infoLevelInfo[level || 'ok'].color,
      top: (top || '0') + 'px',
      right: (right || '0') + 'px',
    }"
  />
</template>

<style lang="scss">
@use "@/styles/variables/colors";

.info-marker {
  pointer-events: none;
  position: absolute;
  height: 14px;
  width: 14px;
  border-radius: 7px;
  border: 2px solid colors.$border-inverse;
}
</style>
